module.exports = __webpack_public_path__ + "assets/img/equLoss.86cae9da.png";